const EventsArray2022 = [
    {
        link: "https://www.icissconf.org/",
        title: "The International Conference on Information Systems Security (ICISS) 2022",
        dt: "16-20",
        my: "Dec"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/GIAN COURSE_2022.pdf",
        title: "GIAN Course on 'Total Factor Productivity and Macroeconomic Development: Issues and Implications' (Virtual Event).",
        dt: "12-19",
        my: "Dec"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/National Energy Conservation Day Celebration Brochure.jpg",
        title: "National Energy Conservation Day Celebration",
        dt: "16",
        my: "Dec"
    },
    {
        link: "#geosp",
        title: "Workshop on 'Geospatial Data Science'",
        dt: "9-14",
        my: "Dec"
    },
    {
        link: "https://iittp.ac.in/workshop",
        title: "Workshop on 'Advanced Metrology'",
        dt: "5-9",
        my: "Dec"
    },
    {
        link: "#cmp",
        title: "Workshop on 'Credit Markets and Policies in South Asia: Issues and Challenges",
        dt: "7-9",
        my: "Dec"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/Technical Business Idea Call for.png",
        title: 'Call for "Smart Laundry System Solution Proposal"',
        dt: "8",
        my: "Dec"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2023/National Pollution Control Day Celebration .jpg",
        title: "Pollution Control Day Celebration",
        dt: "3",
        my: "Dec"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/FDP_brochure.pdf",
        title: 'ATAL’s Continuous Professional Development Programmes / Faculty Development Programmes on "Additive and Smart Manufacturing for Biomedical Applications"',
        dt: "14-25",
        my: "Nov"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2023/JSPS_ICSSR Seminat_IITT_IGES.jpg",
        title: 'Understanding and Addressing Systemic Risks Behind the Socio-economic Impacts of COVID-19 in India and Japan: Developing a Roadmap for a Resilient and Sustainable Future',
        dt: "21-22",
        my: "Nov"
    },
    {
        link: "#ww",
        title: "Workshop on Writing R D Grant Proposal for Women Engineers",
        dt: "10-11",
        my: "Nov"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/Start-up.jpeg",
        title: 'How to do a "START-UP" - An Interactive Session Talk',
        dt: "12",
        my: "Nov"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/CII poster.jpeg",
        title: 'CII Industry - Academia Conclave Prominent Speaker: Director, IIT Tirupati.',
        dt: "9",
        my: "Nov"
    },
    {
        link: "#DFI",
        title: '11th Annual Conference on Deep Foundation Technologies for Infrastructure Development',
        dt: "15-17",
        my: "Sep"
    },
    {
        link: "#camost",
        title: "CAMOST's Second Anniversary Colloquium Series",
        dt: "10",
        my: "Sep"
    },
    {
        link: "#workshop_08",
        title: 'Pre-incubation Contest',
        dt: "12",
        my: "Aug-Sep"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/csrc/LTM_Brochure.pdf",
        title: 'Interactive session "From Lab to Market"',
        dt: "25",
        my: "Aug"
    },
    {
        link: "#event_08",
        title: 'New Students Orientation Programme',
        dt: "25-26",
        my: "Jul"
    },
    {
        link: "#workshop_07",
        title: '1st Workshop on "Emerging Learning Methods and Systems" (ELMS) jointly organized by IIT Tirupati and University of Agder (UiA), Norway.',
        dt: "15-17",
        my: "Jul"
    },
    {
        link: "#instyogaday",
        title: 'International Day of Yoga 2022',
        dt: "21",
        my: "Jun"
    },
    {
        link: "#workshop",
        title: 'One Day Scientific Workshop on "Nanomechanical Nanotribological Testing".',
        dt: "03",
        my: "Jun"
    },
    {
        link: "#roundtable",
        title: 'Roundtable on Sustainability during Crisis.',
        dt: "15",
        my: "May"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Public Policy Lecture Series_9.pdf",
        title: 'Public Policy Special Lecture Series (Curtain-raiser Event for the MPP program): Lecture by Dr. Vijayendra Rao, Head and Lead Economist, World Bank, USA.',
        dt: "22",
        my: "Apr"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Public Policy Lecture Series_8.pdf",
        title: 'Public Policy Special Lecture Series',
        dt: "08",
        my: "Apr"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Brochure_March 24   25 2022_IITT.pdf",
        title: 'International Conference on “Tackling Climate Change through Urban Resilience: Role of Institutions and Public Policies in Canada and India” [Online]',
        dt: "24-25",
        my: "Mar"
    },
    {
        link: "#wpom",
        title: 'Indo-Canadian Symposium on "Water: Purification, Optimization Management"',
        dt: "17-18",
        my: "Mar"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/HSSIWBrochure.pdf",
        title: 'International Workshop on "Public Policies for the Post-Pandemic Era"',
        dt: "24-25",
        my: "Feb"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Public Policy Lecture Series_7.pdf",
        title: 'Public Policy Special Lecture Series - Department of Humanities and Social Sciences',
        dt: "18",
        my: "Feb"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Cross Environmental Ethics.pdf",
        title: 'GIAN Course - Cross Environmental Ethics: Challenges and Potential',
        dt: "5-27",
        my: "Mar"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Brochure_GIAN Course on Migration and Citizenship.pdf",
        title: 'GIAN MoE Course - Migration and Citizenship',
        dt: "14-23",
        my: "Mar"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Public Policy Lecture Series_1.1.pdf",
        title: 'Public Policy Special Lecture Series - Department of Humanities and Social Sciences',
        dt: "06",
        my: "Jan"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Atal-FDP-CSD-Brochure.pdf",
        title: 'Faculty Development Program - Computer System Design',
        dt: "03-07",
        my: "Jan"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Industry Academia Conclave - Manufacturing - Brouchure.pdf",
        title: 'Industry Academia Conclave- Manufacturing on 7th Jan, 2022',
        dt: "07",
        my: "Jan"
    }
];


export default EventsArray2022